import { memo } from 'react';
import classNames from 'classnames';

import styles from './PlpViewTypeSelector.module.scss';
import SegmentedControl from '../segmented-control/SegmentedControl';
import { usePlpViewType } from '../../hooks/usePlpViewType';
import gridSvg from './grid.svg';
import ListSvg from './list.svg';

import {
  dispatchImmediateAnalyticsEvent,
  PLP_VIEW_TYPE_SELECTED,
} from '../analytics/analyticsEvents';

type Props = {
  className: 'aboveControls' | 'inControls';
  name: 'aboveControls' | 'inControls';
};

// TO DO: Delete these and import icon components from the design system
// (The List and Grid icons will be added to the design system after v23)
const GridIcon = () => {
  return <img src={gridSvg} alt="Grid Icon" width="24" height="24" />;
};
const ListIcon = () => {
  return <img src={ListSvg} alt="List Icon" width="24" height="24" />;
};

const PlpViewTypeSelector = ({ className, name }: Props) => {
  const { isListView, onViewSelectionChange } = usePlpViewType(
    'PlpViewTypeSelector'
  );

  const segmentedControlOptions = [
    {
      label: 'Grid',
      value: 'grid',
      selected: isListView ? false : true,
      IconComponent: GridIcon,
      iconTitle: 'Grid view',
    },
    {
      label: 'List',
      value: 'list',
      selected: isListView ? true : false,
      IconComponent: ListIcon,
      iconTitle: 'List view',
    },
  ];

  const onSegmentedControlClick = (value: 'grid' | 'list') => {
    onViewSelectionChange(value);
    dispatchImmediateAnalyticsEvent(PLP_VIEW_TYPE_SELECTED, {
      plpViewType: value,
    });
  };

  return (
    <SegmentedControl
      isMultiSelect={false}
      className={classNames(styles.plpViewTypeSelector, styles[className])}
      name={name}
      segments={segmentedControlOptions}
      callback={onSegmentedControlClick}
    />
  );
};

export default memo(PlpViewTypeSelector);
